const settings = {
    local: {
        apiUrl: `http://localhost:8082/multim/public/api`,
        email: "multim.api@gis.si",
        password: "9560dh7h67ti58f8578e4fh34as9gjgtu28"
    },
    server: {
        apiUrl: `http://178.238.236.24/multim/public/api`,
        email: "multim.api@gis.si",
        password: "9560dh7h67ti58f8578e4fh34as9gjgtu28"
    }
}

export default settings;